import React from 'react';
import { Box, styled } from '@mui/material';

const StyledMainHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: theme.spacing(2),
  backgroundColor: theme.palette.background.paper,
  borderBottom: `1px solid ${theme.palette.divider}`,
  minHeight: 64,
}));

const MainHeader = ({ children, ...props }) => {
  return (
    <StyledMainHeader {...props}>
      {children}
    </StyledMainHeader>
  );
};

export default MainHeader;